import api from '../lib/axios';
export async function getSettings() {
    const { data } = await api.get('/api/admin/settings');
    return data;
}
export async function updateAppearance(body) {
    await api.patch('/api/admin/settings/appearance', body);
}
export async function updateHomeWidgets(modules) {
    await api.patch('/api/admin/settings/home-widgets', { default_home_modules: modules });
}
export async function updateModules(body) {
    await api.patch('/api/admin/settings/modules', body);
}
export async function updateConnectors(connectors) {
    await api.patch('/api/admin/settings/connectors', { connectors });
}
export async function updateDirectory(body) {
    await api.patch('/api/admin/settings/directory', body);
}
/** Adresse du site public de l'affichage légal (publi.macommunelive.fr). */
export const LEGAL_ACTS_PUBLIC_URL = 'https://publi.macommunelive.fr';
/**
 * Affichage légal : référencement du site public des actes par les moteurs de recherche,
 * et site officiel de la commune (lien retour de la page publique des actes).
 */
export async function updateLegalActs(body) {
    await api.patch('/api/admin/settings/legal-acts', body);
}
/** Délibération fixant le mode de publicité : ajoutée à l'historique. */
export async function recordPublicityMode(body) {
    await api.post('/api/admin/settings/publicity-mode', body);
}
export async function updateRefuge(body) {
    await api.patch('/api/admin/settings/refuge', body);
}
export async function updateWebsite(body) {
    await api.patch('/api/admin/settings/website', body);
}
export async function updateLegal(body) {
    await api.patch('/api/admin/settings/legal', body);
}
export async function updateServicesOrder(order) {
    await api.patch('/api/admin/settings/services-order', { services_order: order });
}
export async function getCustomDomain() {
    const { data } = await api.get('/api/admin/settings/custom-domain');
    return data.data;
}
export async function setCustomDomain(domain) {
    const { data } = await api.put('/api/admin/settings/custom-domain', { domain });
    return data.data;
}
export async function verifyCustomDomain() {
    const { data } = await api.post('/api/admin/settings/custom-domain/verify');
    return data;
}
export async function removeCustomDomain() {
    await api.delete('/api/admin/settings/custom-domain');
}
